const downloadRoutes = []
export default downloadRoutes
